import React from 'react';

export default function TimesheetsEndOfPublishedPeriodSVG() {
  return (
    <svg
      version="1.1"
      id="ux-skill"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="75px"
      height="90px"
      viewBox="0 0 95 110"
      enableBackground="new 0 0 95 110"
      xmlSpace="preserve"
    >
      <line fill="#F9F9F9" x1="17.1" y1="30.8" x2="78.2" y2="91.9" />
      <path
        fill="#2133f2"
        d="M78.2,93.4c-0.4,0-0.8-0.1-1.1-0.4L16.1,31.9c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l61.1,61.1
                                c0.6,0.6,0.6,1.5,0,2.1C78.9,93.2,78.6,93.4,78.2,93.4z"
      />
      <line fill="#F9F9F9" x1="78.2" y1="30.8" x2="17.1" y2="91.9" />
      <path
        fill="#2133f2"
        d="M17.1,93.4c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1l61.1-61.1c0.6-0.6,1.5-0.6,2.1,0
                                c0.6,0.6,0.6,1.5,0,2.1L18.2,92.9C17.9,93.2,17.5,93.4,17.1,93.4z"
      />
      <line fill="#F9F9F9" x1="47.7" y1="18.2" x2="47.7" y2="104.5" />
      <path
        fill="#2133f2"
        d="M47.7,106c-0.8,0-1.5-0.7-1.5-1.5V18.2c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v86.3
                                C49.1,105.3,48.5,106,47.7,106z"
      />
      <line fill="#F9F9F9" x1="90.8" y1="61.3" x2="4.5" y2="61.3" />
      <path
        fill="#2133f2"
        d="M90.8,62.8H4.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h86.3c0.8,0,1.5,0.7,1.5,1.5S91.7,62.8,90.8,62.8z"
      />
      <line fill="#F9F9F9" x1="7.8" y1="44.8" x2="87.5" y2="77.9" />
      <path
        fill="#2133f2"
        d="M87.5,79.4c-0.2,0-0.4,0-0.6-0.1l-79.8-33c-0.8-0.3-1.1-1.2-0.8-1.9c0.3-0.8,1.2-1.1,1.9-0.8l79.8,33
                                c0.8,0.3,1.1,1.2,0.8,1.9C88.7,79,88.1,79.4,87.5,79.4z"
      />
      <line fill="#F9F9F9" x1="64.2" y1="21.5" x2="31.1" y2="101.2" />
      <path
        fill="#2133f2"
        d="M31.1,102.7c-0.2,0-0.4,0-0.6-0.1c-0.8-0.3-1.1-1.2-0.8-1.9l33-79.8c0.3-0.8,1.2-1.1,1.9-0.8
                                c0.8,0.3,1.1,1.2,0.8,1.9l-33,79.8C32.3,102.4,31.7,102.7,31.1,102.7z"
      />
      <line fill="#F9F9F9" x1="31.1" y1="21.5" x2="64.2" y2="101.2" />
      <path
        fill="#2133f2"
        d="M64.2,102.7c-0.6,0-1.1-0.3-1.4-0.9L29.8,22c-0.3-0.8,0-1.6,0.8-1.9c0.8-0.3,1.6,0,1.9,0.8l33,79.8
                                c0.3,0.8,0,1.6-0.8,1.9C64.6,102.7,64.4,102.7,64.2,102.7z"
      />
      <line fill="#F9F9F9" x1="87.5" y1="44.8" x2="7.8" y2="77.9" />
      <path
        fill="#2133f2"
        d="M7.8,79.4c-0.6,0-1.1-0.3-1.4-0.9c-0.3-0.8,0-1.6,0.8-1.9l79.8-33c0.8-0.3,1.6,0,1.9,0.8
                                c0.3,0.8,0,1.6-0.8,1.9l-79.8,33C8.2,79.3,8,79.4,7.8,79.4z"
      />
      <path
        fill="#F9F9F9"
        d="M80.6,61.3c0,18.2-14.8,33-33,33c-18.2,0-33-14.8-33-33c0-18.2,14.8-33,33-33
                                C65.9,28.4,80.6,43.1,80.6,61.3"
      />
      <path
        fill="#F9F9F9"
        d="M75.2,61.3c0,15.2-12.3,27.5-27.5,27.5S20.1,76.5,20.1,61.3c0-15.2,12.3-27.5,27.5-27.5
                                S75.2,46.1,75.2,61.3"
      />
      <path
        fill="#2133f2"
        d="M47.7,90.3c-16,0-29-13-29-29s13-29,29-29s29,13,29,29S63.7,90.3,47.7,90.3z M47.7,35.3
                                c-14.4,0-26,11.7-26,26s11.7,26,26,26s26-11.7,26-26S62,35.3,47.7,35.3z"
      />
      <g
        id="pupil"
        style={{
          transformOrigin: '27px -40px 0px',
          transform: 'matrix(1, 0, 0, 1, 0, 0)'
        }}
      >
        <path
          fill="#2133f2"
          d="M63.4,61.3c0,8.7-7,15.7-15.7,15.7c-8.7,0-15.7-7-15.7-15.7c0-8.7,7-15.7,15.7-15.7
                                    C56.3,45.6,63.4,52.7,63.4,61.3"
        />
        <path
          fill="#F9F9F9"
          d="M61.2,48c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6s2.7-6,6-6C58.5,42,61.2,44.6,61.2,48"
        />
      </g>
      <g opacity="0" id="blink" style={{ opacity: 0 }}>
        <path
          fill="#F9F9F9"
          d="M75.2,61.3c0,15.2-12.3,27.5-27.5,27.5c-15.2,0-27.5-12.3-27.5-27.5c0-15.2,12.3-27.5,27.5-27.5
                                    C62.9,33.8,75.2,46.1,75.2,61.3"
        />
        <path
          fill="#2133f2"
          d="M75.2,62.8h-55c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h55c0.8,0,1.5,0.7,1.5,1.5S76,62.8,75.2,62.8z"
        />
      </g>
      <path
        fill="#2133f2"
        d="M47.7,90.3c-16,0-29-13-29-29s13-29,29-29s29,13,29,29S63.7,90.3,47.7,90.3z M47.7,35.3
                                c-14.4,0-26,11.7-26,26s11.7,26,26,26s26-11.7,26-26S62,35.3,47.7,35.3z"
      />
    </svg>
  );
}
